import React from 'react'
import { Content } from './Content'
import { Provider } from './Context'

export const Page = () => {
  return (
    <Provider>
      <Content />
    </Provider>
  )
}
